import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=809db3bc&scoped=true&"
import script from "./CustomFields.vue?vue&type=script&lang=js&"
export * from "./CustomFields.vue?vue&type=script&lang=js&"
import style0 from "./CustomFields.vue?vue&type=style&index=0&id=809db3bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809db3bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('809db3bc')) {
      api.createRecord('809db3bc', component.options)
    } else {
      api.reload('809db3bc', component.options)
    }
    module.hot.accept("./CustomFields.vue?vue&type=template&id=809db3bc&scoped=true&", function () {
      api.rerender('809db3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BookingFields/CustomFields.vue"
export default component.exports